module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "conteudo"
    }
  }, [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "problemaAcessoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "problemaAcessoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Abrir SAU",
      "icone": "fa-external-link"
    },
    on: {
      "clicado": function($event) {
        return _vm.abreSau()
      }
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    attrs: {
      "role": "login"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-offset-1 col-md-5 col-lg-offset-2 col-lg-4",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "card card-banner",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "container container-login"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.valida($event)
      }
    }
  }, [_c('div', {
    staticClass: "container container-input container-input-text"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("SSHD")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:8'),
      expression: "'required|min:8|max:8'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.username),
      expression: "usuario.username"
    }],
    staticClass: "form-control-credential",
    class: _vm.errorInputUsername,
    attrs: {
      "type": "text",
      "name": "username",
      "data-vv-as": "SSHD",
      "value": "",
      "id": "username",
      "placeholder": "sshd",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.usuario.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])])]), _vm._v(" "), _c('div', {
    staticClass: "container container-input container-input-text",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.password),
      expression: "usuario.password"
    }],
    staticClass: "form-control-credential",
    class: _vm.errorInputPassword,
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "senha",
      "data-vv-as": "Senha"
    },
    domProps: {
      "value": (_vm.usuario.password)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkCapsLock($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-addon-right",
    on: {
      "click": function($event) {
        return _vm.mostraSenha()
      }
    }
  }, [(_vm.senhaVisivel) ? _c('i', {
    staticClass: "fa fa-eye-slash fa-lg"
  }) : _c('i', {
    staticClass: "fa fa-eye fa-lg"
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-5 col-lg-6"
  }, [_c('div', {
    staticClass: "card card-default",
    attrs: {
      "id": "login-description"
    }
  }, [_c('h3', [_vm._v("Links Informativos")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', [_vm._v("Adição de documento")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', [_vm._v("\n              Clique para acessar:\n              "), _c('div', {
    staticClass: "contain-link"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('declaracao-ausencia.doc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Declaração de Comparecimento\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('ANEXO I - O.S. 001-2022-GPM - VERBA TRANSPORTE - SOLICITAÇÃO.doc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Verba Transporte - Solicitação\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('ANEXO II - O.S. 001-2022-GPM - VERBA TRANSPORTE - DESCRIÇÃO DE CONSUMO.xls')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Verba Transporte - Descrição De Consumo\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-ferias.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual do Agendamento de Férias\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-de-procedimentos.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual de Procedimentos DEGEPAT\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual-de-especificacoes-tecnicas-de-epi.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual de Especificações Técnicas de EPI\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('cartilha_capep.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cartilha de Informações da CAPEP\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('artemis_consignado.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual do Sistema Artemis Versão Mobile\n                      (Consignado)\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('documento_basico_e_orientativo_sobre_pgr.pdf')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Documento Básico e Orientativo sobre PGR\n                      ")])])])])])]), _vm._v(" "), _c('h3', [_vm._v("Esqueceu sua Senha?")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "problemaAcessoModalLabel"
    }
  }, [_vm._v("\n              Problemas de Acesso\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Você digitou suas credenciais com algum erro por 3 vezes\n                  seguidas.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Por favor,\n                  "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau/",
      "target": "blank"
    }
  }, [_vm._v("\n                    abra um SAU")]), _vm._v("\n                  contando-nos que está com problema de acesso e faremos os\n                  ajustes necessários.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "page-header-bg logo-login hidden-xs",
    attrs: {
      "id": "header-bg-login"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input",
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold",
      "padding-top": "7px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px",
      "vertical-align": "bottom"
    },
    attrs: {
      "src": require("../../assets/SshdLogo.png"),
      "alt": "Logotipo SSHD"
    }
  }), _vm._v("\n                SSHD\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input"
  }, [_vm._v("\n                Entre com sua conta da prefeitura\n                "), _c('br'), _vm._v("para acessar o sistema\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-addon"
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-input"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Login\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n              Clique para acessar:\n              "), _c('div', {
    staticClass: "contain-link"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Holerite\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Estatuto\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://app.pmsantos.lecom.com.br/bpm",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Processos Digitais\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Informe IR\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                     Perícia Médica\n                  ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=pdymO6b7jCg&feature=youtu.be",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual Entrega\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-uteis"
  }, [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/websshd",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Trocar Senha\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('p', [_vm._v("Para redefinição e geração de uma nova senha temporária, procure o "), _c('strong', [_vm._v("Gestor de SSHD/Senhas")]), _vm._v(" de sua Unidade.")]), _vm._v(" "), _c('strong', [_vm._v("Suporte técnico:")]), _vm._v(" (13) 3213-2755\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c919c1e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/index.vue
// module id = R583
// module chunks = 5